angular.module('picmonicng').directive('browseSref', [
  'BrowseService',
  function (BrowseService) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('click', function () {
          scope.$apply(function () {
            if (attrs.browseSref) {
              var params = attrs.browseSrefParams ? scope.$eval(attrs.browseSrefParams) : {};
              BrowseService.go(attrs.browseSref, params);
            }
          });
        });
      },
    };
  },
]);
